import { Button, Step } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useMultistepFormStore } from "@components/common/MultistepForm";

interface AddStep {}

const AddStep: FC = () => {
  const { t } = useTranslation();
  const { setAddSectionOpen } = useMultistepFormStore();

  return (
    <>
      <Step>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<FeatherIcon icon="plus-circle" size={16} />}
          onClick={() => setAddSectionOpen(true)}
        >
          {t("multistep.editor.createQuestionGroup")}
        </Button>
      </Step>
    </>
  );
};

export default AddStep;
